var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    staticClass: "box",
    attrs: {
      title: _vm.$t("方案说明"),
      visible: _vm.dialogVisible,
      footer: null,
      width: 1000
    },
    on: {
      cancel: () => {
        _vm.$emit("cancel");
      }
    }
  }, _vm._l(_vm.list, function (item) {
    return _c("div", {
      key: item.id
    }, [_c("div", {
      staticClass: "name"
    }, [_vm._v(" " + _vm._s(item.name) + "-" + _vm._s(_vm.$t("保障额度")) + _vm._s(item.amount) + _vm._s(_vm.$t(_vm.i18nCurrencyUnit(_vm.$store.state.user.accountInfo.customerId))) + " ")]), _c("a-table", {
      staticStyle: {
        width: "100%"
      },
      attrs: {
        bordered: "",
        columns: _vm.columns,
        "data-source": item.rightsCont,
        align: "center",
        pagination: false,
        rowKey: "id"
      }
    }, _vm._l(_vm.columns, function (item, i) {
      var _item$slots, _item$slots2, _item$slots3;
      return _c("span", {
        key: i,
        attrs: {
          slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
        },
        slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
      }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
    }), 0)], 1);
  }), 0);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };